// OLD
const autoModels = window.models || window.oldmodels || [];

// --- helpers ---
const cleanText = s => (s ?? "")
  .toString()
  .normalize("NFKC")
  .replace(/[\u200B-\u200D\uFEFF]/g, "")
  .replace(/\u00A0/g, " ")
  .replace(/\s+/g, " ")
  .trim();

const slugify = (s = "") =>
  cleanText(s)
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

const onlyUnique = (v, i, a) => a.indexOf(v) === i;

const sortByText = (a, b) =>
  cleanText(a).localeCompare(cleanText(b), undefined, { sensitivity: "base" });

function setPlaceholder(sel, text, enabled = false) {
  sel.innerHTML = "";
  const opt = document.createElement("option");
  opt.value = "";
  opt.textContent = text;
  opt.disabled = true;
  opt.selected = true;
  sel.appendChild(opt);
  sel.disabled = !enabled;
  sel.classList.toggle("inactive", !enabled);
}

// ============================================================
// SELECTED BIKE STORAGE
// ============================================================
const BIKE_STORAGE_KEY = "selected_bike";

function saveSelectedBike({ brand, model, year, url } = {}) {
  const bike = {
    brand: cleanText(brand),
    model: cleanText(model),
    year: cleanText(year),
    url: url || null,
    savedAt: Date.now()
  };

  if (!bike.brand || !bike.model) return null;

  try {
    localStorage.setItem(BIKE_STORAGE_KEY, JSON.stringify(bike));
  } catch (_) {
    // storage full / disabled (Safari private mode) — fail silently
  }

  // let the rest of the theme react without polling
  document.dispatchEvent(new CustomEvent("bike:selected", { detail: bike }));

  return bike;
}

function getSelectedBike() {
  try {
    const raw = localStorage.getItem(BIKE_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && parsed.brand && parsed.model ? parsed : null;
  } catch (_) {
    return null;
  }
}

function clearSelectedBike() {
  try {
    localStorage.removeItem(BIKE_STORAGE_KEY);
  } catch (_) {}
  document.dispatchEvent(new CustomEvent("bike:cleared"));
}

// expose for other snippets / Liquid blocks
window.saveSelectedBike = saveSelectedBike;
window.getSelectedBike = getSelectedBike;
window.clearSelectedBike = clearSelectedBike;

// --- build lookups ---
const mergedModels = new Map();

for (const raw of autoModels) {
  const brandKey = cleanText(raw.brand);
  const modelKey = cleanText(raw.model);
  const mergedKey = `${brandKey}|||${modelKey}`.toLowerCase();

  const years = Array.isArray(raw.years)
    ? raw.years.map(cleanText).filter(Boolean)
    : [];

  if (!mergedModels.has(mergedKey)) {
    mergedModels.set(mergedKey, {
      ...raw,
      brand: brandKey,
      model: modelKey,
      years: [...years],
      link: raw.link
    });
  } else {
    const existing = mergedModels.get(mergedKey);

    const seenYears = new Set(existing.years.map(y => cleanText(y).toLowerCase()));
    for (const y of years) {
      const yKey = cleanText(y).toLowerCase();
      if (!seenYears.has(yKey)) {
        seenYears.add(yKey);
        existing.years.push(y);
      }
    }

    const oldLink = existing.link;
    const newLink = raw.link;

    if (!oldLink && newLink) {
      existing.link = newLink;
    } else if (Array.isArray(oldLink) || Array.isArray(newLink)) {
      const oldArr = Array.isArray(oldLink) ? oldLink : (oldLink ? [oldLink] : []);
      const newArr = Array.isArray(newLink) ? newLink : (newLink ? [newLink] : []);
      existing.link = [...oldArr, ...newArr];
    } else if (
      oldLink && typeof oldLink === "object" &&
      newLink && typeof newLink === "object" &&
      !Array.isArray(oldLink) &&
      !Array.isArray(newLink)
    ) {
      existing.link = { ...oldLink, ...newLink };
    }
  }
}

const mergedAutoModels = Array.from(mergedModels.values());

const brands = mergedAutoModels
  .map(m => m.brand)
  .filter(Boolean)
  .filter(onlyUnique)
  .sort(sortByText);

const brandToModels = new Map();
const modelByName = new Map();

for (const m of mergedAutoModels) {
  const brandKey = m.brand;
  const modelKey = m.model;
  const key = `${brandKey}|||${modelKey}`.toLowerCase();

  if (!brandToModels.has(brandKey)) brandToModels.set(brandKey, []);
  brandToModels.get(brandKey).push(m);
  modelByName.set(key, m);
}

for (const list of brandToModels.values()) {
  list.sort((a, b) => sortByText(a.model, b.model));
}

document.addEventListener("DOMContentLoaded", () => {

// --- DOM refs ---
const selBrands = document.getElementById("brands");
const selModels = document.getElementById("models");
const selYears  = document.getElementById("years");

if (!selBrands || !selModels || !selYears) return;

// --- initial placeholders ---
setPlaceholder(selBrands, "Brand ↓", true);
setPlaceholder(selModels, "Model ↓", false);
setPlaceholder(selYears,  "Year ↓",  false);

// populate brands
for (const b of brands) {
  const opt = document.createElement("option");
  opt.value = b;
  opt.textContent = b;
  selBrands.appendChild(opt);
}

// --- events ---
selBrands.addEventListener("change", function () {
  const brand = cleanText(this.value);
  if (!brand) return;

  setPlaceholder(selModels, "Model ↓", true);
  setPlaceholder(selYears,  "Year ↓",  false);

  const list = brandToModels.get(brand) || [];

  // See all option
  const seeAll = document.createElement("option");
  seeAll.value = "__see_all__";
  seeAll.textContent = `→ See all ${brand}`;
  selModels.appendChild(seeAll);
  selModels.disabled = false;
  selModels.classList.remove("inactive");

  // Deduped models
  const seenModels = new Set();

  for (const m of list) {
    const modelName = cleanText(m.model);
    const key = modelName.toLowerCase();
    if (!modelName || seenModels.has(key)) continue;
    seenModels.add(key);

    const opt = document.createElement("option");
    opt.value = modelName;
    opt.textContent = modelName;
    selModels.appendChild(opt);
  }
});

selModels.addEventListener("change", function () {
  const selected = cleanText(this.value);
  if (!selected) return;

  setPlaceholder(selYears, "Year ↓", true);

  if (selected === "__see_all__") {
    const brandSlug = slugify(selBrands.value || "");
    if (brandSlug) window.location.href = `/collections/${brandSlug}`;
    return;
  }

  const brand = cleanText(selBrands.value);
  const model = modelByName.get(`${brand}|||${selected}`.toLowerCase());

  if (!model || !Array.isArray(model.years) || model.years.length === 0) {
    setPlaceholder(selYears, "No years available", false);
    return;
  }

  const toLink = (year, idx) => {
    const L = model.link;
    if (!L) return null;
    if (typeof L === "string") return L;
    if (Array.isArray(L)) return L[idx] || null;
    if (typeof L === "object") return L[year] || null;
    return null;
  };

  model.years.forEach((year, idx) => {
    const cleanYear = cleanText(year);
    const url = toLink(cleanYear, idx);
    const opt = document.createElement("option");
    opt.value = String(cleanYear);
    opt.textContent = String(cleanYear);
    if (url) opt.dataset.link = url;
    selYears.appendChild(opt);
  });
});

selYears.addEventListener("change", function () {
  const val = cleanText(this.value);
  if (!val) return;

  const selectedOpt = this.options[this.selectedIndex];
  const link = selectedOpt?.dataset.link;
  const selectedModel = cleanText(selModels.value);
  const selectedBrand = cleanText(selBrands.value);

  // --- persist the bike before we navigate ---
  saveSelectedBike({
    brand: selectedBrand,
    model: selectedModel,
    year: val,
    url: link
  });

  try {
    const m = modelByName.get(`${selectedBrand}|||${selectedModel}`.toLowerCase());
    if (window.gtag && m) {
      gtag("event", "bike_selector_used", {
        event_category: m.brand,
        event_label: selectedModel
      });
    }
    if (window.fndTrack) {
      fndTrack("Bike Selector Used", { brand: selectedBrand, model: selectedModel, year: val });
    }
  } catch (_) {}

  if (link) window.location.href = link;
});

// --- brand auto-select on /collections/[brand] ---
const match = window.location.pathname.match(/\/collections\/([^\/?#]+)/i);
if (match?.[1]) {
  const slug = match[1].toLowerCase();
  const matchBrand = brands.find(b => slugify(b) === slug);
  if (matchBrand) {
    (window.requestAnimationFrame || setTimeout)(() => {
      selBrands.value = matchBrand;
      selBrands.dispatchEvent(new Event("change"));
    }, 0);
  }
}

}); // end DOMContentLoaded


// ============================================================
// BIKE TYPEAHEAD
// ============================================================
document.addEventListener("DOMContentLoaded", function bikeTypeaheadPerRange() {
  if (typeof autoModels === "undefined") {
    console.warn("[bike-typeahead] autoModels not found.");
    return;
  }

  const input = document.getElementById("bike-typeahead-input");
  if (!input) return;

  // Create portal once
  let portal = document.getElementById("bike-typeahead-portal");
  if (!portal) {
    portal = document.createElement("ul");
    portal.id = "bike-typeahead-portal";
    portal.setAttribute("role", "listbox");
    portal.setAttribute("aria-label", "Bike results");
    document.body.appendChild(portal);
  }

  // ---------- helpers ----------
  const clean = (s = "") => (s ?? "")
    .toString()
    .normalize("NFKC")
    .replace(/[\u200B-\u200D\uFEFF]/g, "")
    .replace(/\u00A0/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  function prettyRangeLabel(raw) {
    const str = clean(raw).replace(/[–—]/g, "-");
    const m = str.match(/^([^()]+)(\s*\(.*\))?$/);
    const head = (m?.[1] || str)
      .replace(/\s*-\s*/g, "-")
      .replace(/\s*\+\s*$/, "+")
      .replace(/\s+/g, " ");
    const tail = m?.[2] ? m[2].replace(/\s+/g, " ") : "";
    return head + tail;
  }

  function urlFor(model, idx) {
    const L = model.link;
    if (!L) return null;
    if (Array.isArray(L)) return L[idx] || L[L.length - 1] || null;
    if (typeof L === "string") return L;
    if (typeof L === "object") {
      const wanted = prettyRangeLabel(model.years[idx] || "");
      for (const k in L) {
        if (prettyRangeLabel(k).toLowerCase() === wanted.toLowerCase()) return L[k];
      }
      const firstKey = Object.keys(L)[0];
      return firstKey ? L[firstKey] : null;
    }
    return null;
  }

  // pull the stored-bike fields back off a result link
  const bikeFromEl = el => el ? {
    brand: el.dataset.brand,
    model: el.dataset.model,
    year: el.dataset.year
  } : null;

  // --- tokenised search ---
  function makeTokens(...parts) {
    const set = new Set();
    for (let p of parts) {
      if (!p) continue;
      p = clean(p).toLowerCase();
      p = p.replace(/[–—]/g, "-").replace(/[(),/]/g, " ").replace(/[\-+]/g, " ");
      p = p.replace(/([a-z])(\d)/gi, "$1 $2").replace(/(\d)([a-z])/gi, "$1 $2");
      p = p.replace(/\s+/g, " ").trim();
      if (!p) continue;
      const toks = p.split(" ");
      for (const t of toks) {
        set.add(t);
        set.add(t.replace(/\s+/g, ""));
      }
    }
    return Array.from(set);
  }

  function queryTokens(q) {
    const parts = clean(q).toLowerCase().split(/\s+/).filter(Boolean);
    const set = new Set();
    for (const part of parts) {
      for (const t of makeTokens(part)) set.add(t);
    }
    return Array.from(set);
  }

  function tokensMatch(entryTokens, qTokens) {
    if (!qTokens.length) return false;
    return qTokens.every(qt => entryTokens.some(t => t === qt || t.startsWith(qt)));
  }

  // Build index lazily on first search — ensures window.models is populated
  let perRangeIndex = null;

  function getIndex() {
    if (perRangeIndex) return perRangeIndex;

    const source = window.models || window.oldmodels || [];
    perRangeIndex = [];
    const seen = new Set();

    for (const raw of source) {
      const brand = clean(raw.brand);
      const model = clean(raw.model);
      const years = Array.isArray(raw.years) ? raw.years.map(clean) : [];

      years.forEach((rawLabel, i) => {
        const label = prettyRangeLabel(rawLabel);
        const href = urlFor({ ...raw, years }, i);
        if (!href) return;

        const key = `${brand}|${model}|${label}|${href}`.toLowerCase();
        if (seen.has(key)) return;
        seen.add(key);

        perRangeIndex.push({
          brand,
          model,
          label,
          url: href,
          hay: (brand + " " + model + " " + label).toLowerCase(),
          tokens: makeTokens(brand, model, label)
        });
      });
    }

    return perRangeIndex;
  }

  // ---------- UI / portal ----------
  function positionPortal() {
    // Set position via individual properties (not cssText) so we don't clobber
    // the display value that showPortal()/clearPortal() are managing.
    const r = input.getBoundingClientRect();
    portal.style.position = "fixed";
    portal.style.zIndex = "999999";
    portal.style.top = `${r.bottom + 6}px`;
    portal.style.left = `${r.left}px`;
    portal.style.width = `${r.width}px`;
  }

  let activeIndex = -1;

  function render(items) {
    portal.innerHTML = "";

    if (!items.length) {
      const li = document.createElement("li");
      li.className = "is-empty";
      li.setAttribute("aria-disabled", "true");
      li.style.cssText = "padding:10px 12px; color:#aaa;";
      li.textContent = "No matches";
      portal.appendChild(li);
    } else {
      const frag = document.createDocumentFragment();

      items.forEach((it, i) => {
        const li = document.createElement("li");
        li.setAttribute("role", "option");
        li.className = "result-item";

        const a = document.createElement("a");
        a.href = it.url;
        a.target = "_self";
        a.rel = "nofollow";
        a.textContent = `${it.brand} ${it.model} - ${it.label}`;

        // carry the bike through to the click/Enter handlers
        a.dataset.brand = it.brand;
        a.dataset.model = it.model;
        a.dataset.year  = it.label;

        a.addEventListener("mouseenter", () => {
          activeIndex = i;
          updateActive();
        });
        a.addEventListener("focus", () => {
          activeIndex = i;
          updateActive();
        });

        li.appendChild(a);
        frag.appendChild(li);
      });

      portal.appendChild(frag);
    }

    showPortal();
    input.setAttribute("aria-expanded", "true");
    activeIndex = -1;
    updateActive();
    positionPortal();
  }

  function updateActive() {
    portal.querySelectorAll("li.result-item").forEach((el, idx) => {
      el.classList.toggle("is-active", idx === activeIndex);
    });
  }

  function showPortal() {
    portal.style.display = "block";
  }

  function clearPortal() {
    portal.style.display = "none";
    portal.innerHTML = "";
    input.setAttribute("aria-expanded", "false");
    activeIndex = -1;
  }

  // ---- hardened close + navigation ----
  let closeTimer = null;

  input.addEventListener("blur", () => {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(clearPortal, 280);
  });

  portal.addEventListener("pointerdown", e => {
    clearTimeout(closeTimer);
    e.stopPropagation();
  });
  portal.addEventListener("mousedown", e => {
    clearTimeout(closeTimer);
    e.stopPropagation();
  });
  portal.addEventListener("touchstart", e => {
    clearTimeout(closeTimer);
    e.stopPropagation();
  }, { passive: true });

  function go(href, bike) {
    if (!href) return;

    // --- persist the bike before we navigate ---
    if (bike) saveSelectedBike({ ...bike, url: href });

    if (window.fndTrack) {
      fndTrack("Bike Selector Used", {
        brand: bike?.brand || "",
        model: bike?.model || "",
        year: bike?.year || ""
      });
    }

    try {
      clearTimeout(closeTimer);
      clearPortal();
      window.location.assign(href);
      setTimeout(() => {
        if (document.visibilityState === "visible") window.location.href = href;
      }, 50);
    } catch (err) {
      const tmp = document.createElement("a");
      tmp.href = href;
      document.body.appendChild(tmp);
      tmp.click();
      tmp.remove();
    }
  }

  portal.addEventListener("pointerdown", e => {
    const a = e.target.closest("a");
    if (!a) return;
    e.preventDefault();
    e.stopPropagation();
    go(a.getAttribute("href"), bikeFromEl(a));
  });

  portal.addEventListener("click", e => {
    const a = e.target.closest("a");
    if (!a) return;
    e.preventDefault();
    e.stopPropagation();
    go(a.getAttribute("href"), bikeFromEl(a));
  });

  // --- search (tokenised) ---
  function search(qRaw) {
    const q = clean(qRaw);
    if (!q) { clearPortal(); return; }

    const qTok = queryTokens(q);

    let results = getIndex().filter(it => tokensMatch(it.tokens, qTok));

    const score = (it) => {
      let s = 0;
      for (const qt of qTok) {
        for (const t of it.tokens) {
          if (t === qt) s += 3;
          else if (t.startsWith(qt)) s += 2;
        }
      }
      return -s;
    };

    results = results
      .sort((a, b) =>
        score(a) - score(b) ||
        a.brand.localeCompare(b.brand) ||
        a.model.localeCompare(b.model) ||
        a.label.localeCompare(b.label)
      )
      .slice(0, 30);

    render(results);
  }

  // Events
  let debounceTimer;

  input.addEventListener("input", function () {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => search(this.value), 80);
  });

  input.addEventListener("focus", function () {
    if (clean(this.value)) search(this.value);
    positionPortal();
  });

  // Keyboard nav and Enter-to-go
  document.addEventListener("keydown", function (e) {
    if (portal.style.display === "none" || !portal.style.display === "") return;

    const links = Array.from(portal.querySelectorAll("a"));
    if (!links.length) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      activeIndex = Math.min(activeIndex + 1, links.length - 1);
      updateActive();
      links[activeIndex]?.focus({ preventScroll: true });
      links[activeIndex]?.scrollIntoView({ block: "nearest" });
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      activeIndex = Math.max(activeIndex - 1, 0);
      updateActive();
      links[activeIndex]?.focus({ preventScroll: true });
      links[activeIndex]?.scrollIntoView({ block: "nearest" });
    } else if (e.key === "Enter") {
      if (document.activeElement === input) {
        e.preventDefault();
        const el = links[activeIndex] || links[0];
        if (el?.href) go(el.href, bikeFromEl(el));
      }
    } else if (e.key === "Escape") {
      clearPortal();
      input.focus();
    }
  });

  window.addEventListener("scroll", () => {
    if (portal.style.display !== "none") positionPortal();
  }, true);

  window.addEventListener("resize", () => {
    if (portal.style.display !== "none") positionPortal();
  });
}); // end DOMContentLoaded (typeahead)


// ============================================================
// HERO ROTATOR
// ============================================================
document.addEventListener("DOMContentLoaded", () => {
  const phrases = [
    "for those who don't hang about 💨",
    "for clean setups 🧼",
    "for your bike 💪",
    "for keeping it low-key 🥷🏻",
    "built for riders on the move 🚀",
    "built to blend in 👀"
  ];

  const el = document.getElementById("hero-rotator");
  if (!el) return;

  let pool = [...phrases];

  const getNext = () => {
    if (!pool.length) pool = [...phrases];
    const i = Math.floor(Math.random() * pool.length);
    return pool.splice(i, 1)[0];
  };

  el.textContent = getNext();

  /*
  // -------- ENABLE THIS IF YOU WANT ROTATION BACK --------
  setInterval(() => {
    el.classList.add("fade-out");

    setTimeout(() => {
      el.textContent = getNext();
      el.classList.remove("fade-out");
      el.classList.add("fade-in");

      setTimeout(() => {
        el.classList.remove("fade-in");
      }, 500);
    }, 500);
  }, 6000);
  */
}); // end DOMContentLoaded (hero rotator)